import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { StudentSummaryVM } from "@shared-kernel/application/ports/student/student-repository";
import { retrieveStudentSummary } from "./retrieve-student-summary";

const initialState: RetrievalState<StudentSummaryVM | null> = { fetching: "idle", data: null };

export const retrieveStudentSummaryReducer = createReducer<RetrievalState<StudentSummaryVM | null>>(initialState, builder => {
  builder.addCase(retrieveStudentSummary.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveStudentSummary.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveStudentSummary.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
